import React from 'react'
import { RouteComponentProps } from 'react-router'
import { Route, Switch } from 'react-router-dom'
import StaffList from './staff-list/staff-list'
import StaffApply from './staff-apply/staff-apply'
import StaffOperateRecord from './staff-operate-record/staff-operate-record'

const path = '/main/staff'

export const STAFF_LIST = path + '/list'
export const STAFF_OPERATE_RECORD = path + '/operateRecord'
export const STAFF_APPLY_RECORD = path + '/applyRecord'

export default (props: RouteComponentProps) => {
    return (
        <Switch>
            <Route path={props.match.path + '/list'} component={StaffList}></Route>
            <Route path={props.match.path + '/applyRecord'} component={StaffApply}></Route>
            <Route path={props.match.path + '/operateRecord'} component={StaffOperateRecord} />
        </Switch>
    )
}
